import React, { useState } from 'react'

import cogniLogo from '../../images/cogni_logo.png'
import LoginImage from '../../images/signup.png'
import { ErrorCross } from '../common/icons'
import './signup.css'
import { SignUpSuccess } from './Sucess'
import { Loader } from '../common/loader/loader'
import { useHistory } from "react-router-dom";
import { isBlockedDomain } from '../common/isBlockedDomain'

const errorMessages = {
    0: 'Email is invalid.',
    1: 'Email or password is incorrect',
    2: 'Only Corporate emails are allowed',
}

const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const resetErrors = (setEmailAsInvalid) => () => {
    setEmailAsInvalid({ status: false })
}

const handleEmailChange = (setEmail) => (e) => setEmail(e.target.value)

const handleInvalidEmail = (props) => (e) => {
    e.preventDefault()
    if (!EmailRegex.test(props.email)) {
        props.setIsEmailInvalid({ status: true, msg: errorMessages[0] })
        props.enableSubmit(false)
    } else if (isBlockedDomain(props.email)) {
        props.setIsEmailInvalid({ status: true, msg: errorMessages[2] })
        props.enableSubmit(false)
    } else {
        props.setIsEmailInvalid({ status: false, msg: '' })
        props.enableSubmit(true)
    }
    return false
}

export const SignUp = (props) => {
    const [email, setEmail] = useState('')
    const [isInvalidEmail, setIsEmailInvalid] = useState({
        status: false,
        msg: errorMessages[0],
    })
    const [submitEnabled, enableSubmit] = useState(false)
    const [showSuccessPage] = useState(false)
    const [showLoading] = useState(false)

    return !showSuccessPage ? (
        <Wrapper>
            <LeftPanel />
            {showLoading ? (
                <ChildWrapper showHeaderTitle={false}>
                    <Loader.PopupLoader show={true} />
                </ChildWrapper>
            ) : (
                <ChildWrapper showHeaderTitle={true}>
                    <form>
                        <InputForm
                            isInvalidEmail={isInvalidEmail}
                            email={email}
                            setIsEmailInvalid={setIsEmailInvalid}
                            setEmail={setEmail}
                            enableSubmit={enableSubmit}
                        />
                        <SubmitButton
                            submitEnabled={submitEnabled}
                                email={email}
                                {...props}
                        />
                        <div className="content_signup">
                            <p className="content_p">
                                By signing up, you accept our{' '}
                                <span>
                                    {' '}
                                    <a href="https://workativ.com/terms">
                                        Terms and Conditions{' '}
                                    </a>
                                </span>
                            </p>
                            <span>
                                <a href="https://workativ.com/privacy">
                                    Privacy
                                </a>
                            </span>
                        </div>
                    </form>
                    <BottomMenu {...props} />
                </ChildWrapper>
            )}
        </Wrapper>
    ) : (
        <SignUpSuccess email={email} />
    )
}

function Wrapper(props) {
    return (
        <div className="login_bg_height signup">
            <div className="login_bg_width">
                <div className="row">{props.children}</div>
            </div>
        </div>
    )
}

function ChildWrapper(props) {
    return (
        <div className="col-md-6 col-lg-6 login_bg_width_left_right sign_up_head">
            {props.showHeaderTitle && (
                <h3>
                    <span>Signup</span>
                </h3>
            )}
            <div className="login_bg_width_left_right_form">
                {props.children}
            </div>
        </div>
    )
}

function LeftPanel() {
    return (
        <div className="col-md-6 col-lg-6 login_bg_width_left">
            <img
                className="centerImage"
                src={cogniLogo}
                alt="Assistant"
                title="Assistant"
            />
            <h2>
                Welcome to <span> Workativ Assistant</span>
            </h2>
            <p>Initiate your signup process by providing your email id.</p>
            <div className="left_bottom_img">
                <img
                    src={LoginImage}
                    align="middle"
                    alt="Login_img"
                    title="Login_img"
                />
            </div>
        </div>
    )
}

function InputForm(props) {
    const {
        isInvalidEmail,
        email,
        setIsEmailInvalid,
        setEmail,
        enableSubmit,
    } = props
    return (
        <React.Fragment>
            <div
                className={
                    isInvalidEmail.status
                        ? 'form-group form-group_error'
                        : 'form-group'
                }
            >
                <label htmlFor="email">Email Address</label>
                {isInvalidEmail.status ? (
                    <span>{isInvalidEmail.msg}</span>
                ) : null}
                <input
                    type="text"
                    // onBlur={handleInvalidEmail({ setIsEmailInvalid: setIsEmailInvalid, email, enableSubmit: enableSubmit })}
                    className="form-control"
                    id="email"
                    value={email}
                    placeholder="Enter your email id..."
                    onChange={(e) => {
                        handleEmailChange(setEmail)(e)
                        handleInvalidEmail({
                            setIsEmailInvalid: setIsEmailInvalid,
                            email: e.target.value,
                            enableSubmit: enableSubmit,
                        })(e)
                    }}
                    onInput={resetErrors(setIsEmailInvalid)}
                />
                {isInvalidEmail.status && email.length > 0 ? (
                    <ErrorCross onClick={() => setEmail('')} />
                ) : null}
            </div>

            <div className="form-group form-check signup_h5">
                <h5>*Only organisation emails are valid.</h5>
            </div>
        </React.Fragment>
    )
}

function SubmitButton(props) {
    const { submitEnabled, email } = props
    const history = useHistory()

    return (
        <button
            className="btn btn-primary"
            disabled={!submitEnabled}
            onClick={(e) => {
                history.push(`${process.env.REACT_APP_UI_BASE_URL}${process.env.REACT_APP_UI_DIRECT_SIGNUP}?email=${email}`)
                e.preventDefault()
            }}
        >
            Submit
        </button>
    )
}

function BottomMenu(props) {
    return (
        <div className="_g0login_account">
            <div className="_g0login_account_left">
                <h5>Already have an account?</h5>
            </div>
            <div className="_g0login_account_right">
                <h5>
                    Go to{' '}
                    <span
                        onClick={() =>
                            props.history.push(
                                process.env.REACT_APP_UI_BASE_URL
                            )
                        }
                    >
                        signin
                    </span>
                </h5>
            </div>
        </div>
    )
}
